import { render, staticRenderFns } from "./PositionControls.vue?vue&type=template&id=7d663148&scoped=true"
import script from "./PositionControls.vue?vue&type=script&lang=js"
export * from "./PositionControls.vue?vue&type=script&lang=js"
import style0 from "./PositionControls.vue?vue&type=style&index=0&id=7d663148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d663148",
  null
  
)

export default component.exports